import { render, staticRenderFns } from "./liveShop.vue?vue&type=template&id=df36b604&scoped=true"
import script from "./liveShop.vue?vue&type=script&lang=js"
export * from "./liveShop.vue?vue&type=script&lang=js"
import style0 from "./liveShop.vue?vue&type=style&index=0&id=df36b604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36b604",
  null
  
)

export default component.exports